import { getIncomingMessage } from "../../root/modules/incoming-messages/get-incoming-message.js";
import { handleIncomingMessages } from "../../root/modules/incoming-messages/handle-incoming-messages.js";
import { loggingContexts } from "../../root/modules/logs/data/logging-contexts.js";
import { log } from "../../root/modules/logs/log.js";
import { trackPubNubMessageData } from "../../root/modules/telemetry/track-pubnub-message-data.js";
import { getPubNubInstance } from "./get-pubnub-instance.js";
import { handlePubNubStatus } from "./handle-pubnub-status.js";

const pubNubListenersLog = log(loggingContexts.pubnubListeners);

export function connectToPubNub({ channel, productKey }) {
  const pubnub = getPubNubInstance({ channel, productKey });

  pubnub.addListener({
    message: async (message) => {
      const possiblyFormattedMessage = message.message
        ? {
            ...message.message,
            originalTopLevelContent: { ...message, message: undefined },
          }
        : message;

      pubNubListenersLog.info("message", possiblyFormattedMessage);

      const { id } = message?.message || {};

      let alreadyHandled = false;

      if (id) {
        try {
          alreadyHandled = Boolean(await getIncomingMessage({ id }));
        } catch (error) {
          pubNubListenersLog.error(
            "duplicate check failed; processing message anyway",
            { id, error: error?.message }
          );
        }
      }

      if (alreadyHandled) {
        pubNubListenersLog.info(
          "duplicate message — already handled, ignoring",
          { id }
        );

        return;
      }

      handleIncomingMessages({ message });
      trackPubNubMessageData({ message });
    },
    status: (event) => {
      pubNubListenersLog.info("status", event);

      handlePubNubStatus({ event });
    },
  });
}
